
import { BaseService } from './baseservice';

class ReportsServiceClass extends BaseService {

    async removeKpiIndicator(data) {
        const response = await this.fetch(
            'PUT',
            '/remove_indicator',
            data
        );

        if (response && response.data) {
            return response.data;
        }
    }


    async load(url) {
        const response = await this.fetch('GET', url);

        if (response && response.data) {
            return response.data;
        }
    }

    async paste(payload, report, org) {
        const response = await this.fetch('PUT', '/org/' + org + '/paste/' + report, { data: payload });

        if (response && response.data) {
            return response.data;
        }
    }

    async saveKpi(body) {
        body.position = 0;
        const response = await this.fetch('POST', '/kpis', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateKpi(body) {
        const response = await this.fetch('PUT', '/kpis/' + body.id, body);

        if (response && response.data) {
            return response.data;
        }
    }

    async updateKpiPosition(body) {
        const response = await this.fetch('PUT', '/kpis/' + body.id + '/position', body);

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteKpi(id) {
        const response = await this.fetch('DELETE', '/kpis/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    async saveEmployee(body) {
        body.locked = 0;
        const response = await this.fetch('POST', '/employees', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateEmployee(body) {
        const response = await this.fetch('PUT', '/employees/' + body.id, body);

        if (response && response.data) {
            return response.data;
        }
    }

    async updateTeam(body, model) {
        const endpoint = model === 'activity'? '/metrics/' : '/teams/';
        const response = await this.fetch('PUT', endpoint + body.id, body);

        if (response && response.data) {
            return response.data;
        }
    }

    async saveTeam(body, model) {
        const endpoint = model === 'activity'? '/metrics' : '/teams';
        body.position = 0;
        const response = await this.fetch('POST', endpoint, body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateTeamPosition(body) {
        const response = await this.fetch('PUT', '/teams/' + body.id + '/position', body);

        if (response && response.data) {
            return response.data;
        }
    }

    async updateEmployeePosition(body) {
        const response = await this.fetch('PUT', '/employees/' + body.id + '/position', body);

        if (response && response.data) {
            return response.data;
        }
    }

    async saveSection(body) {
        body.position = 0;
        const response = await this.fetch('POST', '/sections', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateSection(body) {
        const response = await this.fetch('PUT', '/sections/' + body.id, body);

        if (response && response.data) {
            return response.data;
        }
    }

    async updateSectionPosition(body) {
        const response = await this.fetch('PUT', '/sections/' + body.id + '/position', body);

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteSection(id) {
        const response = await this.fetch('DELETE', '/sections/' + id);

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteEmployee(id) {
        const response = await this.fetch('DELETE', '/employees/' + id);

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteEmployeeMetrics(id) {
        const response = await this.fetch('GET', '/employees/' + id + '/metrics/remove');

        if (response && response.data) {
            return response.data;
        }
    }

    async deleteTeam(id) {
        const response = await this.fetch('DELETE', '/teams/' + id);

        if (response && response.data) {
            return response.data;
        }
    }

    async saveKpiData(body) {
        const response = await this.fetch('POST', '/kpi_data', body);
        if (response && response.data) {
           return response.data;
        }
    }

    async saveEmployeeStat(body) {
        const response = await this.fetch('POST', '/employee_stats', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async saveEmployeeActivity(body) {
        const response = await this.fetch('POST', '/employee_activity', body);
        if (response && response.data) {
            return response.data;
        }
    }

    //---------------------//
    //         HR         //
    //--------------------//

    // Censuses
    async saveCensus(body) {
        const response = await this.fetch('POST', '/termination_censuses', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateCensusData(body) {
        const response = await this.fetch('PUT', '/termination_censuses/' + body.id, body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    async deleteCensus(id) {
        const response = await this.fetch('DELETE', '/termination_censuses/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    // Hr pasting
    async hrPasting(body, org) {
        const response = await this.fetch('PUT', '/org/' + org + '/hr_pasting', body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    // Candidate
    async updateCandidateData(body, model) {
        const response = await this.fetch('PUT', '/'+ model + '/' + body.id, body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    async saveCandidate(body) {
        const response = await this.fetch('POST', '/candidates', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async updateCandidate(body) {
        const response = await this.fetch('PUT', '/candidates/'+body.id, body);
        if (response && response.data) {
            return response.data;
        }
    }

    async deleteCandidate(id) {
        const response = await this.fetch('DELETE', '/candidates/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    // Candidate Trackings
    async updateCandidateTRacking(body) {
        const response = await this.fetch('PUT', '/candidate_trackings/'+body.id, body);
        if (response && response.data) {
            return response.data;
        }
    }

    // Staffing Budget
    async saveStaffingBudget(body) {
        const response = await this.fetch('POST', '/staffing_budget', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async deleteStaff(id) {
        const response = await this.fetch('DELETE', '/staff/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    // Options
    async saveOption(body) {
        const response = await this.fetch('POST', '/dashboard_options', body);
        if (response && response.data) {
            return response.data;
        }
    }

    // Staff
    async saveStaff(body) {
        const response = await this.fetch('POST', '/staff', body);
        if (response && response.data) {
            return response.data;
        }
    }

    async getExternalUsers() {
        const response = await this.fetch('GET', '/externals');
        if (response && response.data) {
            return response.data;
        }
    }

    async getUsersPermissions(org_id){
        const response = await this.fetch('GET', '/permissions/organization/' + org_id);
        if (response && response.data) {
            return response.data;
        }
    }


    // Toggle External user
    async toogleExternalUser(id) {
        const response = await this.fetch('PUT', '/externals/' + id + '/toggle');
        if (response && response.data) {
            return response.data;
        }
    }

    async deleteExternalUser(id) {
        const response = await this.fetch('DELETE', '/externals/' + id);
        if (response && response.data) {
            return response.data;
        }
    }

    async saveExternalUser(body) {
        const response = await this.fetch('POST', '/externals', body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    async updatePermission(org_id, user_id, section, value){
        const response = await this.fetch('PUT', '/permissions/organization/'
            + org_id + '/user/' + user_id + '/section/' + section + '/set/' + value);

        if (response && response.data) {
            return response.data;
        }
    }

    // Staffing budget staff data
    async saveStaffingBudgetStaffData(body) {
        const response = await this.fetch('POST', '/staffing_budget_staff', body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    // Staffing aggregate data
    async updateMonthlyTracker(body) {
        const response = await this.fetch('POST', '/monthly_tracker', body);
        if (response && response.data) {
            return response.data;
        }
        return true;
    }

    /**
     * Detect if the cursor is on the top of the element
     */
    isElementTopPosition(e) {
        const targetRect = e.target.getBoundingClientRect();
        const relativePosY = e.clientY - targetRect.top;

        return relativePosY < (targetRect.height / 2);
    }

    getOrganizationEmployees(org_id) {
        return this.fetch('GET', '/organizations/' + org_id + '/employees');
    }

    getEmployeeMetrics(employee_id) {
        return this.fetch('GET', '/employees/' + employee_id + '/metrics');
    }

    saveEmployeeMetrics(employee_id, metrics) {
        const finalMetrics = [];

        metrics.forEach((metric, index) => {
            finalMetrics.push(metric);
        });

        return this.fetch('POST', '/employees/' + employee_id + '/metrics',
            {employee_id, metrics: finalMetrics});
    }

    removeEmployeeActivityIndicator(data) {
        return this.fetch('put', '/employee_activity/remove_indicator', data);
    }

    saveRoleMetrics(role_id, body) {
        return this.fetch('POST', '/teams/' + role_id + '/metrics', body);
    }

    getRoleMetrics(role_id) {
        return this.fetch('GET', '/teams/' + role_id + '/metrics');
    }

    async updateMetricNotes(metric_id, team_id, body) {
        const response = await this.fetch('PUT', '/teams/' + team_id + '/metrics/' + metric_id + '/notes', body);
        if (response && response.data) {
            return response.data;
        }
    }
}

export function getValidMonthsForYTD(headers, year, type = 'YTD') {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return headers.filter(header => {
        if (!header.includes('/')) return false;
        const [monthName, headerYear] = header.split('/');
        const monthIndex = months.indexOf(monthName);

        if (+year < currentYear) return true;
        if (+year > currentYear) return false;

        return monthIndex <= currentMonth;

        return false;
    });
}

export function calculateTotal(values, formula = 'SUM') {
    const valid = values.filter(v => v !== null && v !== undefined && v !== '' && !isNaN(v) != 0);
    if (!valid.length) return 0;
    if (formula === 'AVG') {
        return valid.reduce((a, b) => a + Number(b), 0) / valid.length;
    }

    return valid.reduce((a, b) => a + Number(b), 0);
}

export function getValidPeriodsForYTD(headers, year, reportType = 'monthly') {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth() + 1;
    const months = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    
    if (reportType === 'weekly') {
        return headers.filter(header => {
            if (!/^\d{2}\/\d{2}\/\d{4}$/.test(header)) return false;
            const [mm, dd, yyyy] = header.split('/').map(Number);
            if (yyyy !== +year) return false;
            const headerDate = new Date(yyyy, mm - 1, dd);
            return headerDate <= currentDate;
        });
    } else if (reportType === 'quarterly') {
        // For quarterly reports, headers are q1, q2, q3, q4
        return headers.filter(header => {
            if (!header.startsWith('q')) return false;
            
            // Determine which quarter the current month belongs to
            let currentQuarter;
            if (currentMonth <= 3) currentQuarter = 1;
            else if (currentMonth <= 6) currentQuarter = 2;
            else if (currentMonth <= 9) currentQuarter = 3;
            else currentQuarter = 4;
            
            // Extract quarter number from header (q1, q2, q3, q4)
            const quarterNumber = parseInt(header.substring(1));

            if (+year < currentYear) return true;
            if (+year > currentYear) return false;

            // Only include quarters that have been completed or are in progress
            return quarterNumber <= currentQuarter;
        });
    } else {
        return headers.filter(header => {
            let monthName, headerYear;
            if (header.includes('/')) {
                [monthName, headerYear] = header.split('/');
                if (+headerYear !== +year) return false;
            } else {
                monthName = header;
                headerYear = year;
            }
            const monthIndex = months.indexOf(monthName);
            if (+year < currentYear) return true;
            if (+year > currentYear) return false;
            return monthIndex <= currentMonth;
        });
    }
}

export function calculateKpiYTDValues(kpi, year, ytd_formula, subMenu, reportType = 'monthly') {
    if (!kpi || !kpi.kpiData) return { actual: '', budget: '', py: '' };
    let months = getValidPeriodsForYTD(Object.keys(kpi.kpiData), year, reportType);
    let actuals = months.map(function(m) { return kpi.kpiData[m] && kpi.kpiData[m].actual !== undefined ? kpi.kpiData[m].actual : undefined; }).filter(function(v) { return v !== undefined; });
    let budgets = months.map(function(m) { return kpi.kpiData[m] && kpi.kpiData[m].budget !== undefined ? kpi.kpiData[m].budget : undefined; }).filter(function(v) { return v !== undefined; });
    let pys = months.map(function(m) { return kpi.kpiData[m] && kpi.kpiData[m].py !== undefined ? kpi.kpiData[m].py : undefined; }).filter(function(v) { return v !== undefined; });
    
    if (ytd_formula === 'AVG') {
        actuals = actuals.filter(function(v) { return v > 0; });
        budgets = budgets.filter(function(v) { return v > 0; });
        pys = pys.filter(function(v) { return v > 0; });
    }
    if (subMenu === 'ya_vs_py') {
        return {
            actual: calculateTotal(actuals, ytd_formula),
            py: calculateTotal(pys, ytd_formula)
        };
    } else if (subMenu === 'quarterly') {
        pys = months.map(function(m) { return kpi.kpiData[m] && kpi.kpiData[m].prior_year !== undefined ? kpi.kpiData[m].prior_year : undefined; }).filter(function(v) { return v !== undefined; });
        return {
            actual: calculateTotal(actuals, ytd_formula),
            budget: calculateTotal(budgets, ytd_formula),
            py: calculateTotal(pys, ytd_formula)
        };
    } else {
        return {
            actual: calculateTotal(actuals, ytd_formula),
            budget: calculateTotal(budgets, ytd_formula)
        };
    }
}

let ReportsService = new ReportsServiceClass(ENVIRONMENT.API_HOST);
export default ReportsService;
